import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

export default {
  namespaced: true,
  state: {
    user: null,
  },
  actions,
  mutations,
  getters,
};
